import { HomeOwnershipType } from ".";
import {
  EuerDeclarationOfficeUsageSubformFullCostInputs,
  EuerDeclarationOfficeUsageSubformCalculationResults,
} from "./types";
import { validateOfficeUsageInputs } from "./utils";

const calculateHomeOfficeExpenses = (
  inputs: EuerDeclarationOfficeUsageSubformFullCostInputs
): number => {
  const {
    monthsUsed,
    officeArea,
    totalHomeArea,
    homeOwnershipType,
    usagePeriodOperatingHomeExpenses,
    annualOtherHomeExpenses,
    annualOtherOfficeExpenses,
  } = inputs;

  const usagePeriodShare = monthsUsed / 12;

  const usagePeriodRentOrDepreciation =
    homeOwnershipType === HomeOwnershipType.RENTAL
      ? inputs.monthlyRent * monthsUsed
      : inputs.annualHomeDepreciation * usagePeriodShare;

  const usagePeriodOtherHomeExpenses =
    annualOtherHomeExpenses * usagePeriodShare;

  const usagePeriodHomeExpenses =
    usagePeriodRentOrDepreciation +
    usagePeriodOperatingHomeExpenses +
    usagePeriodOtherHomeExpenses;

  const usagePeriodOtherOfficeExpenses =
    annualOtherOfficeExpenses * usagePeriodShare;

  const officeAreaShare = officeArea / totalHomeArea;

  return Math.round(
    usagePeriodHomeExpenses * officeAreaShare + usagePeriodOtherOfficeExpenses
  );
};

const calculatePaidInputTax = ({
  officeArea,
  totalHomeArea,
  paidHomeExpensesInputTax16,
  paidHomeExpensesInputTax19,
  paidOfficeExpensesInputTax16,
  paidOfficeExpensesInputTax19,
}: EuerDeclarationOfficeUsageSubformFullCostInputs): number => {
  const officeAreaShare = officeArea / totalHomeArea;

  return (
    Math.round(
      (paidHomeExpensesInputTax16 + paidHomeExpensesInputTax19) *
        officeAreaShare
    ) +
    paidOfficeExpensesInputTax16 +
    paidOfficeExpensesInputTax19
  );
};

export const calculateOfficeUsageSubformFullCostResults = (
  inputs: EuerDeclarationOfficeUsageSubformFullCostInputs
): EuerDeclarationOfficeUsageSubformCalculationResults => {
  validateOfficeUsageInputs(inputs);
  const homeOfficeExpenses = calculateHomeOfficeExpenses(inputs);
  const paidInputTax = calculatePaidInputTax(inputs);
  return {
    homeOfficeExpenses,
    paidInputTax,
    profitReduction: homeOfficeExpenses + paidInputTax,
  };
};
